module.exports = __webpack_public_path__ + "static/media/icon-triangle.c979438e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-triangle.svg
// module id = 316
// module chunks = 0